import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import styles from '@/components/Common/FormItem/FormItem.styles';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Switch,
} from '@mui/material';
import { useFiscalDataViewController } from './FiscalDataViewController';

export function FiscalData() {
  const { uiState, actions } = useFiscalDataViewController();

  return (
    <Stack spacing={'12px'} p={{ xs: '16px', md: '0px' }}>
      <FormSectionTitle title={'Datos de Facturación'} subtitle="subtitle" />
      <BasicContainer
        content={
          <Grid container columnSpacing={'20px'} p={'16px'}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={uiState.taxInvoiceRequired}
                    onChange={(e) =>
                      actions.onChangeTaxInvoiceRequired(e.target.checked)
                    }
                  />
                }
                label="Requiero facturas para todos mis pedidos"
                sx={styles.label}
              />
            </Grid>
            {uiState.taxInvoiceRequired && (
              <>
                <Grid item xs={6}>
                  <FormItem label="RFC" helperText={uiState.rfcError}>
                    <OutlinedInput
                      fullWidth
                      value={uiState.rfc}
                      onChange={(e) => actions.onChangedRfc(e.target.value)}
                      error={!!uiState.rfcError}
                    />
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <FormItem
                    label="Régimen Fiscal"
                    helperText={uiState.fiscalRegimeError}
                  >
                    <Select
                      fullWidth
                      value={uiState.fiscalRegime}
                      onChange={actions.handleFiscalRegimeChange}
                    >
                      {uiState.fiscalRegimeOptions.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <FormItem
                    label="Nombre Legal"
                    helperText={uiState.legalNameError}
                  >
                    <OutlinedInput
                      fullWidth
                      value={uiState.legalName}
                      onChange={(e) =>
                        actions.onChangedLegalName(e.target.value)
                      }
                      error={!!uiState.legalNameError}
                    />
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <FormItem
                      label="Uso del CFDI"
                      helperText={uiState.cfdiUseError}
                    >
                      <Select
                        fullWidth
                        value={uiState.cfdiUse}
                        onChange={actions.handleCfdiUseChange}
                      >
                        {uiState.cfdiUseOptions.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormItem>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormItem
                    label="Código Postal Facturación"
                    helperText={uiState.postalCodeError}
                  >
                    <OutlinedInput
                      fullWidth
                      value={uiState.postalCode}
                      onChange={(e) =>
                        actions.onChangedPostalCode(e.target.value)
                      }
                      error={!!uiState.postalCodeError}
                    />
                  </FormItem>
                </Grid>
                <Grid item xs={6}>
                  <FormItem
                    label="Correo electrónico facturación"
                    helperText={uiState.taxEmailError}
                  >
                    <OutlinedInput
                      fullWidth
                      value={uiState.taxEmail}
                      onChange={(e) => actions.onChangedEmail(e.target.value)}
                      error={!!uiState.taxEmailError}
                    />
                  </FormItem>
                </Grid>
              </>
            )}
          </Grid>
        }
        footer={
          uiState.taxInvoiceRequired ? (
            <Stack
              sx={{ flexDirection: 'row-reverse', p: '16px' }}
              gap={'16px'}
            >
              <Button
                variant="contained"
                disabled={uiState.saveDisabled}
                onClick={actions.onClickedSave}
              >
                Guardar
              </Button>
              <Button
                variant="contained"
                disabled={uiState.cancelDisabled}
                onClick={actions.onClickedCancel}
              >
                Cancelar
              </Button>
            </Stack>
          ) : undefined
        }
      />
    </Stack>
  );
}
